import { useEffect } from "react";
import ApiUtils from "../utils/api_utils";
import { setLocalStorage } from "../utils/utilities";

const useWhiteLabel = (props) => {
  const { data } = props;

  useEffect(() => {
    if (data) {
      const { slug } = data;
      setLocalStorage("slug", slug);
      setLocalStorage("orgData", JSON.stringify(data));
      setDynamicTitleAndFavicon(data);
      setStyle(data);
    }
  }, [data]);

  const setDynamicTitleAndFavicon = (retrievedObjectOrg) => {
    const faviconEl = document.getElementById("favicon");

    let data = {
      title: "SKOR",
      favicon: `${process.env.PUBLIC_URL}/favicon.ico`,
    };

    if (retrievedObjectOrg) {
      const { favicon, name } = retrievedObjectOrg;
      data.title = name;
      data.favicon = favicon;
    }

    document.title = data.title;
    faviconEl.href = retrievedObjectOrg
      ? ApiUtils.validateImgUrl({
          url: data.favicon,
        })
      : data.favicon;
  };

  const setStyle = (data) => {
    const style = document.createElement("style");
    style.textContent = `
      :root {
        --main-color: ${
          Object.keys(data).length > 0 ? data.theme_color : "#FF5829"
        };
      }
    `;
    document.head.appendChild(style);
  };
};

export default useWhiteLabel;
